export default __webpack_public_path__ + "static/media/gseLogo.a6b68868.png";